"use client";

import { injectStyles } from "./inject-styles";

/**
 * Optional client component that ensures CSS is injected synchronously
 *
 * CSS is automatically injected via side effect when you import from the package.
 * This component is optional and only needed if you experience timing issues
 * where components render before CSS is injected (rare, but can happen in some SSR setups).
 *
 * Usage (optional):
 * ```tsx
 * import { CSSInjector } from "react-prayer-widget";
 *
 * function Layout() {
 *   return (
 *     <html>
 *       <body>
 *         <CSSInjector />
 *         {children}
 *       </body>
 *     </html>
 *   );
 * }
 * ```
 */
export function CSSInjector() {
	// Inject immediately (synchronously) - don't wait for useEffect
	// This ensures CSS is available before any child components render
	if (typeof window !== "undefined") {
		injectStyles();
	}

	return null;
}

